/**
 * Registers the 'tableObjectStepOne' directive with the provided module.
 * This directive is used to handle the first step in the table object creation process.
 * @param {object} module - The AngularJS module to which the directive will be registered.
 */
export default function registerTableObjectStepOneDirective(module) {
    module.directive('tableObjectStepOne', function tableObjectStepOneDirective() {
        return {
            restrict: 'A',
            replace: true,
            require: '^asfTableObject',
            templateUrl: '/views/ib/contentobjects/table/step1.html',
            link: function (scope, element, attributes, controller) {
                // Retrieve step 1 data from the controller
                const step1Data = controller.getStepData(1);
                // Determine the alignment, defaulting to 'horizontal' if not specified
                const alignment = angular.isDefined(step1Data) && step1Data.alignment ? step1Data.alignment : 'horizontal';

                /**
                 * Handles the click event on the 'Create Table Object' button.
                 * Sets the table alignment and proceeds to the next step.
                 */
                scope.onCreateTableObjectButtonClick = function () {
                    controller.setTableAlignment(alignment);
                    controller.nextStep();
                };
            }
        };
    });
}